import { getEncargaUnCocheUrl } from '#app/shared/lib/external-links.ts'
import { Separator } from '../data-display/Separator'
import { Icon } from '../icons/Icon'
import Link from '../navigation/Link'
import HeaderNav from './HeaderNav'
import HeaderTopBanner from './HeaderTopBanner'
import Logo from './Logo'
import PhoneContactLink from './PhoneContactLink'

// "Encarga un coche" apunta a la app externa (gamaoptima.net), no a la ruta
// interna /encarga-un-coche, que ya no se usa. Se construye en cada render
// porque la URL depende de `ENV`, que no existe al importar el módulo.
const getNavItems = () => [
  { name: 'Nosotros', path: '/sobre-nosotros' },
  { name: 'Nuestros coches', path: '/nuestros-coches' },
  { name: 'Encarga un coche', path: getEncargaUnCocheUrl() },
  { name: 'Vende tu coche', path: '/vende-tu-coche' },
  // { name: 'Financiación', path: '/financia' },
]

type Props = {
  isSticky?: boolean
  isActive: (item: { path: string }) => boolean
  showBanner?: boolean
  mode?: 'full' | 'banner' | 'main'
  isHome?: boolean
}

export default function HeaderDesktop({
  isSticky,
  isActive,
  showBanner = true,
  mode = 'full',
  isHome = false,
}: Props) {
  const showTopBanner = showBanner && (mode === 'full' || mode === 'banner')
  const showMainHeader = mode === 'full' || mode === 'main'
  const headerVariant = isHome ? 'light' : 'dark'
  const backgroundClass = isHome ? 'bg-primary-800' : 'bg-white'

  return (
    <>
      {showTopBanner && <HeaderTopBanner />}

      {showMainHeader && (
        <header
          className={`
            ${backgroundClass}
            ${isSticky ? `sticky top-0 z-[10000]` : ''}
          `}
        >
          <div
            className={`
              mx-auto flex max-w-[1344px] items-center justify-between

              ${backgroundClass}

              px-4 py-[30px]
            `}
          >
            {/* LEFT */}
            <Logo variant={headerVariant} />
            {/* CENTER */}
            <HeaderNav
              headerNavItems={getNavItems()}
              isActive={isActive}
              variant={headerVariant}
            />

            {/* RIGHT */}

            <div className="flex items-center gap-4">
              <PhoneContactLink
                showNumber
                variant={headerVariant}
                iconClassName="text-primary-500"
              />
              <Link to={'/contacto'}>
                <Icon name="basic/mail" size="20px" color="#01A8B2" />
              </Link>
            </div>
          </div>
          <Separator
            className={`!rounded-lg bg-line-gradient-dark opacity-[37%]`}
          />
        </header>
      )}
    </>
  )
}
